module.exports = __webpack_public_path__ + "img/step-3.09cd374d.png";